<template>

    <div class="container card p-5 shadow col-md-5 m-auto">
        
        <h1>Edit Doctor</h1>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">First Name</span>
                </div>
                <input v-model="doctorProfile.firstName" type="text"  class="form-control" placeholder="Enter First Name">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Last Name</span>
                </div>
                <input v-model="doctorProfile.lastName" type="text"  class="form-control" placeholder="Enter Last Name">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Email</span>
                </div>
                <input v-model="doctorProfile.email" type="email"  class="form-control" readonly='true'>
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Riziv</span>
                </div>
                <input v-model="doctorProfile.riziv" type="text"  class="form-control" placeholder="Enter Riziv" >
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Phone</span>
                </div>
                <input v-model="doctorProfile.phoneNumber" type="text"  class="form-control" placeholder="Enter Phone" >
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">City</span>
                </div>
                <input v-model="doctorProfile.city" type="text"  class="form-control" placeholder="Enter City" >
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Address</span>
                </div>
                <input v-model="doctorProfile.address" type="text"  class="form-control" placeholder="Enter Address" >
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Postcode</span>
                </div>
                <input v-model="doctorProfile.postcode" type="text"  class="form-control" placeholder="Enter Postcode" >
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" for="inputGroupSelect01">Language
                        <img class="img-profile ml-2 rounded-circle" :src="doctorProfile.language.flagImagePath">
                    </span>
                </div>
                <select @change="onSelect($event.target.value)" class="custom-select" id="inputGroupSelect01">
                    <option v-for="(lang,index) in languages" :key="index"  :selected='lang.title == doctorProfile.language.title' :value="lang.id">
                        {{lang.longTitle}} 
                        
                    </option>
                    
                </select>
            </div>
        </div>
        <button @click="editDoctorProfile()" type="button" class="btn btn-primary mb-3">Save Changes</button>
        
    </div>

</template>
<script>
export default {
    data() {
        return {
            doctorProfile :
            {
                "firstName": "",
                "lastName": "",
                "email": "",
                "riziv": "",
                "phoneNumber": "",
                "city": "",
                "postcode": "",
                "address": "",
                "language": {},
                "languageId": ""
            },
            response: {
                success: null,
                message: ""
            },
            languages: [],
            selectedLanguageId: '',
        }
    },
    methods: {
        getDoctorInformation: function(){
            let self = this;
            this.$http.get("/api/doctor/get/" + this.$route.params.id)
                .then(response =>
                {
                    self.doctorProfile = response.data;
                })
                .catch();
        },
        getLanguages: function(){
            let self = this;
            this.$http.get("/api/languages/list")
                .then(response =>
                {
                    self.languages = response.data;
                })
                .catch();
        },
        onSelect: function(value){
            this.selectedLanguageId = value;
        },
        editDoctorProfile: function(){
            let self = this;
            this.doctorProfile.languageId = this.doctorProfile.language.id
            this.$http.put("/api/doctor/edit/" + this.$route.params.id, this.doctorProfile)
                .then(response =>
                {
                    self.response = response.data;
                })
                .catch();
        }
    },
    created: function () {
        this.getLanguages();
        this.getDoctorInformation()
    },
    watch: {
        response: function(val){
            setTimeout(() => {this.response.success = null}, 3000)
        },
        selectedLanguageId: function(val){
            this.doctorProfile.languageId = val;
            var selectedLanguageObj = this.languages.find(obj => {
                return obj.id === val;
            })
            this.doctorProfile.language = JSON.parse(JSON.stringify(selectedLanguageObj));
        }
    }
}
</script>
<style lang="scss" scoped>
div{
    span.input-group-text {
        width: 130px;
    }
}
.rounded-circle {
            height : 1.5rem;
            width : 1.5rem;
        }
</style>

